import { render } from "./UserAccordion.vue?vue&type=template&id=67a0f835&scoped=true&ts=true"
import script from "./UserAccordion.vue?vue&type=script&lang=ts"
export * from "./UserAccordion.vue?vue&type=script&lang=ts"

import "./UserAccordion.vue?vue&type=style&index=0&id=67a0f835&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a0f835"]])

export default __exports__